import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { MAP_INCIDENT_TYPE_TO_URL_PREFIX } from '../constants'

import { saveCommentAndTagsError, saveCommentAndTagsSuccess } from './actions'
import { COMMENT_AND_TAGS_UPDATE_ASYNC } from './constants'

const updateCommentAndTagsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(COMMENT_AND_TAGS_UPDATE_ASYNC.INITIATE),
    mergeMap((action) =>
      api.resolutionCenter
        .saveCommentAndTags(
          action.payload.reportId,
          {
            comment: action.payload.comment,
            isCommunity: action.payload.isSharedComment,
            tags: action.payload.tags,
            classifiedAs: action.payload.reportState,
            communityUser: action.payload.communityUser,
          },
          MAP_INCIDENT_TYPE_TO_URL_PREFIX[action.payload.reportType],
          state$.value.partnerOptions.selectedCompany?.value
        )
        .pipe(
          map((response) =>
            saveCommentAndTagsSuccess(
              response,
              action.payload.reportId,
              action.payload.reportType,
              action.payload.reportState
            )
          ),
          takeUntil(action$.pipe(ofType(COMMENT_AND_TAGS_UPDATE_ASYNC.CANCEL)))
        )
    ),
    catchError((error) => of(epicsErrorHandler(saveCommentAndTagsError, error)))
  )

export default combineEpics(updateCommentAndTagsEpic)
